import { render, staticRenderFns } from "./ExtActProcessInstPicModal.vue?vue&type=template&id=6fae2846&scoped=true&"
import script from "./ExtActProcessInstPicModal.vue?vue&type=script&lang=js&"
export * from "./ExtActProcessInstPicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae2846",
  null
  
)

export default component.exports